"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Twitter = function Twitter(props) {
	return _react2.default.createElement(
		"svg",
		_extends({}, props, { viewBox: "0 0 48 48" }),
		_react2.default.createElement("path", { d: "M44.024 11.78a16.627 16.627 0 0 1-4.724 1.273 8.133 8.133 0 0 0 3.612-4.472 16.614 16.614 0 0 1-5.212 1.962 8.268 8.268 0 0 0-6-2.553 8.124 8.124 0 0 0-8 9.924A23.454 23.454 0 0 1 6.765 9.47a8.014 8.014 0 0 0 2.542 10.792 8.282 8.282 0 0 1-3.72-1.01 8.123 8.123 0 0 0 6.59 8.027 8.363 8.363 0 0 1-3.71.137 8.208 8.208 0 0 0 7.674 5.614A16.72 16.72 0 0 1 3.977 36.38 23.533 23.533 0 0 0 16.57 40.01a23.022 23.022 0 0 0 23.354-24.045 16.544 16.544 0 0 0 4.1-4.185z" })
	);
};

exports.default = Twitter;


//////////////////
// WEBPACK FOOTER
// ./~/react-share-icons/lib/Twitter/index.js
// module id = 177
// module chunks = 0